export default __webpack_public_path__ + "static/media/uxui-designer.1083f346.gif";